import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { http } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { Lock, ArrowLeft } from 'lucide-react';
import PageHero from '@/components/PageHero';

export default function GrowthPlans() {
  const { user } = useAuth();
  const [plans, setPlans] = useState([]);
  useEffect(() => { http.get('/plans').then(r => setPlans(r.data)); }, []);

  return (
    <div className="p-6 lg:px-10 lg:pt-10 space-y-5 lg:space-y-8" data-testid="plans-page">
      <Link to="/app" data-testid="plans-back" className="inline-flex items-center gap-2 text-sm text-navy/60 hover:text-navy">
        <ArrowLeft size={14}/> Back to home
      </Link>
      <PageHero photo="plans" alt="A determined Black man" />
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-gold font-semibold">Growth Plans</p>
        <h1 className="font-heading text-3xl lg:text-5xl mt-1 lg:mt-2">Small steps. Real change.</h1>
        <p className="hidden lg:block text-navy/60 mt-3 max-w-2xl">Guided plans — 7 or 30 days. Daily prompts, small wins, real momentum.</p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 lg:gap-5">
        {plans.map(p => (
          <Link key={p.id} to={`/app/plans/${p.id}`} data-testid={`plan-${p.id}`}
            className="block bg-white rounded-3xl p-6 lg:p-7 card-soft hover:-translate-y-0.5 transition-smooth lg:min-h-[180px] flex flex-col">
            <div className="flex items-center justify-between">
              <p className="text-[10px] lg:text-xs uppercase tracking-widest text-navy/50">{p.days} days · {p.category}</p>
              {p.premium && !user?.is_premium && <Lock size={14} className="text-gold"/>}
            </div>
            <p className="font-heading text-xl lg:text-2xl mt-2">{p.title}</p>
            <p className="text-sm text-navy/60 mt-1 flex-1">{p.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
